import { http } from "@/service/http";

export function logout() {
  return http.get("/user/logout");
}

export function getLoginQrcode() {
  return http.post("/login/getQrcode");
}

export function loginCheck(code) {
  return http.post("/login/check", { code });
}

export function getInviteData() {
  return http.get("/commission/index");
}

export function withdrawList() {
  return http.get("commission/withdrawList");
}

export function tuserList() {
  return http.get("commission/tuserList");
}

export function withDrawApi(data) {
  return http.post("/commission/withdraw", data);
}
